import styled from 'styled-components';

const StyledEmptyContainer = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	opacity: 0;
	pointer-events: none;
`;

export { StyledEmptyContainer };
